var a = { exports: {} };
export {
  a as __module
};
//# sourceMappingURL=index.es151.js.map
